import { render, staticRenderFns } from "./XCheckbox.vue?vue&type=template&id=092d17f6"
import script from "./XCheckbox.vue?vue&type=script&lang=js"
export * from "./XCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports